import { render } from "./SurveyDeliveryProduct.vue?vue&type=template&id=119061c5"
import script from "./SurveyDeliveryProduct.vue?vue&type=script&lang=js"
export * from "./SurveyDeliveryProduct.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__